export const Flow = Object.freeze({
  CHAT: 'chat',
  VIDEO: 'video',
  REPORTING: 'reporting',
  PLAYBOOKS: 'playbooks',
  DEAL: 'deal',
  HYFY_MIGRATION: 'hyfy-migration'
})

export const MeetingsSetupOrder = [
  'setup/profile',
  'setup/password',
  'setup/meetings',
  'setup/extension',
]

export const PlaybooksRoleSetupOrder = [
  'start',
  'setup/enterprise/activate/playbooks',
  'setup/enterprise/profile/playbooks'
]

export const ReportingRoleSetupOrder = [
  'start',
  'setup/enterprise/activate/reporting',
  'setup/enterprise/profile/reporting'
]

export const TouchlessSetupOrder = [
  'start',
  'setup/touchless/welcome',
  'setup/touchless/details',
  'setup/touchless/custom',
  'setup/touchless/install',
]

export const CalendarSeatSetupOrder = [
  'setup/calendaring/activate',
  'setup/calendaring/profile',
  'setup/calendaring/connect',
  'setup/calendaring/select',
  // 'setup/calendaring/extension',
  'setup/calendaring/hooray',
]
